function activateSizeChartTabs() {
    document.querySelectorAll('.tab').forEach(tab => {
        tab.removeEventListener('click', handleTabClick);
        tab.addEventListener('click', handleTabClick);
    });
}

function handleTabClick(event) {
    document.querySelectorAll('.tab, .content').forEach(el => el.classList.remove('active'));
    event.currentTarget.classList.add('active');
    document.getElementById(event.currentTarget.getAttribute('data-tab')).classList.add('active');
}
function activateUnitSwitch() {
    document.querySelectorAll('input[name="unit"]').forEach(radio => {
        radio.removeEventListener('change', handleUnitChange);
        radio.addEventListener('change', handleUnitChange);
    });
}

function handleUnitChange(event) {
    const unit = event.target.value;
    document.querySelectorAll('.unit-switch label').forEach(label => label.classList.remove('active'));
    event.target.parentElement.classList.add('active');
    document.querySelectorAll('td[data-cm]').forEach(cell => {
        cell.textContent = cell.getAttribute(`data-${unit}`);
    });
}
document.addEventListener("DOMContentLoaded", () => {
    activateSizeChartTabs();
    activateUnitSwitch();

    document.querySelectorAll('select[name="id"], input[name="id"]').forEach(select => {
        select.addEventListener('change', () => {
            setTimeout(() => {
                activateSizeChartTabs();
                activateUnitSwitch();
            }, 100);
        });
    });
});
